module.exports = __webpack_public_path__ + "static/media/image_12.fba147dd.jpg";